import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../../components/apiconfig/api-config';
import { FaArrowLeft } from 'react-icons/fa';
import SearchableDropdown from '../../../components/common/SearchableDropdown';

const ImportOrderForm = () => {
  const [formData, setFormData] = useState({
    purchase_contract_no: '',
    order_type: 'DIRECT',
    order_date: '',
    expected_shipment_start: '',
    expected_shipment_end: '',
    quantity_mt: '',
    unit_price_usd: '',
    incoterm: '',

    unit_cost_inr: '',
    remarks: '',
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [purchaseContracts, setPurchaseContracts] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch purchase contracts for dropdown
    const fetchPurchaseContracts = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/masters/dropdown-purchase-contract`, {
          credentials: 'include',
        });
        const data = await res.json();
        if (res.ok && Array.isArray(data.data)) {
          setPurchaseContracts(data.data);
        }
      } catch (err) {
        // Optionally handle error
      }
    };

  

    fetchPurchaseContracts();
 
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
    try {
      const { cost_finalised, ...payload } = formData;
      const res = await fetch(`${API_BASE_URL}/api/import/import-order-post`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage({ type: 'success', text: 'Import Order saved successfully' });
        setFormData({
          purchase_contract_no: '',
          order_type: 'DIRECT',
          order_date: '',
          expected_shipment_start: '',
          expected_shipment_end: '',
          quantity_mt: '',
          unit_price_usd: '',
          incoterm: '',
    
          unit_cost_inr: '',
          remarks: '',
        });
      } else {
        setMessage({ type: 'error', text: data.error || 'Something went wrong' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Server error' });
    }
    setLoading(false);
  };

  return (
    <div className="max-w-8xl mx-auto p-4 bg-white">
      <div className="flex justify-between items-center border-b pb-3 mb-5">
        <h2 className="text-lg font-medium text-gray-800">Vessel Info</h2>
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-[#10a5e9] border border-[#10a5e9] px-3 py-1 text-xs rounded font-normal hover:bg-[#10a5e9] hover:text-white hover:border-[#10a5e9] transition"
        >
          <FaArrowLeft />
          Back
        </button>
      </div>
      
      <form onSubmit={handleSubmit} className="space-y-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm text-gray-700 mb-1">Purchase Contract No *</label>
            <SearchableDropdown
              options={purchaseContracts}
              value={formData.purchase_contract_no}
              onChange={val => setFormData(prev => ({ ...prev, purchase_contract_no: val }))}
              placeholder="Select Purchase Contract"
              displayKey="purchase_contract_no"
              valueKey="purchase_contract_no"
              required
              className=""
              disabled={loading}
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">Order Type *</label>
            <select
              name="order_type"
              value={formData.order_type}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none"
              required
            >
              <option value="DIRECT">DIRECT</option>
              <option value="HSS">HSS</option>
            </select>
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">Order Date *</label>
            <input
              type="date"
              name="order_date"
              value={formData.order_date}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none"
              required
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">Expected Shipment Start</label>
            <input
              type="date"
              name="expected_shipment_start"
              value={formData.expected_shipment_start}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">Expected Shipment End</label>
            <input
              type="date"
              name="expected_shipment_end"
              value={formData.expected_shipment_end}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">Quantity (MT)</label>
            <input
              type="number"
              step="0.001"
              name="quantity_mt"
              value={formData.quantity_mt}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">Unit Price (USD)</label>
            <input
              type="number"
              step="0.01"
              name="unit_price_usd"
              value={formData.unit_price_usd}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none"
            />
          </div>

          <div>
            <label className="block text-sm text-gray-700 mb-1">Incoterm</label>
            <input
              type="text"
              name="incoterm"
              value={formData.incoterm}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none"
            />
          </div>

          

      

          <div>
            <label className="block text-sm text-gray-700 mb-1">Unit Cost (INR)</label>
            <input
              type="number"
              step="0.01"
              name="unit_cost_inr"
              value={formData.unit_cost_inr}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none"
            />
          </div>
        </div>

        <div className="md:col-span-2">
          <label className="block text-sm text-gray-700 mb-1">Remarks</label>
          <textarea
            name="remarks"
            value={formData.remarks}
            onChange={handleChange}
            className="w-full border border-gray-300 px-3 py-1.5 text-sm bg-white focus:outline-none focus:border-blue-400 rounded-none resize-none"
            rows={3}
            autoComplete="off"
          />
        </div>

        <div className="pt-2 flex items-center gap-3">
          <button
            type="submit"
            className="px-4 py-2 text-xs bg-[#10a5e9] text-white font-normal rounded border border-[#10a5e9] hover:bg-[#0e8ac2] transition disabled:opacity-60"
            style={{ minWidth: '110px' }}
            disabled={loading}
          >
            {loading ? 'Saving...' : 'Save Import Order'}
          </button>
          {message && (
            <div className={`text-sm ${message.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
              {message.text}
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default ImportOrderForm;